import styled from 'styled-components';

const LongToolTip = styled.div`
  white-space: nowrap;
`;
export default LongToolTip;
